export const DEVICE_ID = 'custom:device_id';
export const USER_ROLE = 'custom:role';
export const TENANT_ID = 'custom:tenant_id';
export const USER_NAME = 'custom:name';
export const COGNITO_USER_EMAIL = 'email';
export const USER_MOBILE_NUMBER = 'custom:mobile_number';
export const COGNITO_USER_ID = 'sub';

export const USER_EMAIL = 'email';
export const ADDRESS_ONE = 'custom:address_one';
export const ADDRESS_TWO = 'custom:address_two';
export const CITY = 'custom:city';
export const COUNTRY = 'custom:country';
export const PINCODE = 'custom:pincode';
export const USER_STATUS = 'UserStatus';